import styled from 'styled-components';
import media from '../../styled/media';

export const H1 = styled.h1`
  text-align: center;
  font-size: 30px;
  line-height: 32px;
  font-weight: 400;
  margin: 24px 0;
  ${media.tablet`
    font-size: 48px;
    line-height: 70px;
  `}
`;

export const DescriptionContainer = styled.div`
  margin: 0 auto;
  max-width: 800px;
  color: #4a4a4a;
`;

const Description = styled.p`
  text-align: center;
  line-height: 26px;
  margin: 24px 0;
`;

export const PrimaryDescription = styled(Description)`
  font-size: 18px;
  font-weight: 600;
  ${media.tablet`
    font-size: 26px;
    line-height: 45px;
  `}
`;

export const SecondaryDescription = styled(Description)`
  font-size: 16px;
  ${media.tablet`
    font-size: 22px;
    line-height: 38px;
  `}
`;

export const NewsList = styled.div`
  display: grid;
  grid-gap: 22px;
  margin: 40px 0;
  ${media.tablet`
    grid-template-columns: 1fr 1fr;
    margin: 80px 0;
  `}
  ${media.PC`
    grid-template-columns: 1fr 1fr 1fr;
  `}
`;
